<div class="controller-notes-grid-header">
  <label
    class="date-label"
    pTooltip="{{ 'CRM.TOOLTIPS.CN_START_AND_END_TIME' | translate }}"
    tooltipPosition="top"
    >{{ 'CRM.LABEL.START_DATE' | translate }}:
  </label>
  <p-datepicker
    [showButtonBar]="true"
    [(ngModel)]="startDate"
    (onSelect)="onDateChange($event, true)"
    (onTodayClick)="setToDefaultDate()"
    dateFormat="yy-mm-dd"
    [autofocus]="false"
  />
  <label
    class="date-label"
    pTooltip="{{ 'CRM.TOOLTIPS.CN_START_AND_END_TIME' | translate }}"
    tooltipPosition="top"
    >{{ 'CRM.LABEL.END_DATE' | translate }}:
  </label>
  <p-datepicker
    [showButtonBar]="true"
    [(ngModel)]="endDate"
    (onSelect)="onDateChange($event, false)"
    (onTodayClick)="setToDefaultDate()"
    dateFormat="yy-mm-dd"
    [minDate]="startDate"
    [autofocus]="false"
  />
  <app-aor-select-panel
    id="aor-selector"
    (aorChanged)="gotoAORView($event)"
    [selectedBusinessUnits]="selectedBusinessUnits()"
    [(aors)]="aors"
    #aorSel
  />
  <div id="business-units-wrapper">
    <app-business-unit-filter
      (selectedBusinessUnitsChanged)="handleBusinessUnitChange($event)"
      #buFilter
    />
  </div>
  <div class="hide-maintenance">
    <label for="hideMaintenance"
      >{{ 'CRM.LABEL.HIDE_MAINTENANCE' | translate }}:</label
    >
    <p-toggleswitch
      name="hideMaintenance"
      class="maintenance-switch"
      [(ngModel)]="hideMaintenance"
      (onChange)="refresh()"
    />
  </div>
  <button
    pButton
    pRipple
    type="button"
    label="{{ 'COMMON.LABEL.BUTTONS.CLEAR' | translate }}"
    icon="pi pi-fw pi-times"
    class="button p-button-success clear-button"
    (click)="clearScreen()"
  ></button>
  <button
    pButton
    pRipple
    type="button"
    icon="pi pi-fw pi-refresh"
    class="button p-button-success refresh-button"
    (click)="refresh()"
  ></button>
</div>

<app-general-grid
  [values]="elements"
  [columns]="columns"
  [totalRecords]="totalRecords"
  [filterable]="true"
  [screenName]="screenName"
  [rows]="rows"
  [lazy]="true"
  (lazyLoad)="lazyLoad($event)"
  [loading]="isLoading"
  [includeExportCSV]="false"
  (changeViewEvent)="changeViewEvent($event)"
  scrollHeight="calc(100vh - 30vh)"
  [usePaginator]="true"
  [rowsPerPageOptions]="[50, 100, 200]"
  #grid
/>
<div class="break"></div>
<p-toast />
<p-confirmDialog
  header="{{ 'CRM.MESSAGES.HEADERS.DELETE_NOTE' | translate }}"
  icon="pi pi-exclamation-triangle"
  key="main-note-delete"
  rejectButtonStyleClass="p-button-danger"
/>
